<div class="container kite-container">

    <div class="row">
      <div class="col-md-12">
        <h3 class="float-right mr-3">BUSINESS INTELLIGENCE</h3>
        <br>
    </div>
    </div>

    <div class="row">
      <div class="col-10">
        <iframe width="100%" height="800" [src]="activeReport" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>
      <div class="col-2 pt-4">
        <div>
          <ul class="list-group">
              <li class="list-group-item border-bottom pinpointer" *ngFor="let report of company.reports" (click)="loadReport(report)">
                  {{report.name}}
              </li>
          </ul>
        </div>
      </div>
    </div>
</div>
